<template>
  <div v-if="items.length > 0">
    <slot></slot>    
    <CheckboxText
      v-for="item of filtered"
      :key="item.group.uid"
      @click="set(item, 'selected', !item.selected)"
      :checked="item.selected"
    >
      <span class="tag">
        <IconText icon="mdi-domain">{{ item.domain.name }}</IconText>
      </span>

      <div class="icon"><i class="mdi mdi-arrow-right"></i></div>
      <span class="tag is-light is-primary">
        <IconText icon="mdi-monitor-multiple">{{
          item.group.name
        }}</IconText></span
      >
    </CheckboxText>
  </div>
</template>

<script>
export default {
  components: {
    CheckboxText: () => import("@/components/singles/CheckboxText.vue"),
    IconText: () => import("@/components/singles/IconText.vue"),
  },
  props: { min: Number },
  data() {
    return {
      isLoading: false,
      items: [],
      rawItems: [],
    };
  },
  computed: {
    filtered() {
      return this.items.filter((x) => !x.hidden);
    },
  },
  created() {
    this.isLoading = true;
    this.init();
    this.isLoading = false;
  },
  methods: {
    set(item, key, value) {
      const index = this.items.findIndex((x) => x == item);
      this.$set(this.items, index, {
        ...item,
        ...{ [key]: value },
      });

      this.change();
    },
    change() {
      this.isLoading = true;

      const flat = [].concat.apply(
        [],
        this.items
          .filter((x) => x.selected)
          .map((x) =>
            x.packages.map((y) => {
              y.command.added = new Date().toISOString();
              return y;
            })
          )
      );

      this.$emit("change", flat);

      this.$set(
        this,
        "items",
        this.items.map((x) => {
          const hasDups = x.packages.some((y) =>
            flat.some((z) => z.package.name === y.package.name)
          );

          if (!x.selected) x.hidden = hasDups;

          return x;
        })
      );

      this.isLoading = false;
    },
    hasDuplicates(source, flat) {
      return source
        .filter((x) => x.domain.uid === this.$route.params.domainUID)
        .some((x) =>
          x.packages.some((y) =>
            flat.some((z) => z.package.name === y.package.name)
          )
        );
    },

    async init() {
      try {
        const result = await this.$store.dispatch(
          "groupPackage/getAccountGroupPackages",
          { domainUID: this.$route.params.domainUID }
        );

        if (result && result.length > 0) {
          this.rawItems = result;
          this.items = result.filter(
            (x) =>
              x.domain.uid !== this.$route.params.domainUID &&
              x.packages.length >= (this.min || 4) &&
              !this.hasDuplicates(this.rawItems, x.packages)
          );
        }
      } catch (error) {
        console.error(error);
      }
    },
  },
};
</script>
